module.exports = __webpack_public_path__ + "static/media/plus.3d70dc5b.svg";